const l = (n, d) => {
  const { state: a } = n, s = a.tr;
  let c = !1;
  a.doc.descendants((o, e) => {
    const r = e + o.nodeSize;
    o.marks.forEach((t) => {
      if (t.type.name === "link") {
        const i = t.type.create({
          ...t.attrs,
          color: d
        });
        s.removeMark(e, r, t.type).addMark(e, r, i), c = !0;
      }
    });
  }), c && n.view.dispatch(s);
};
export {
  l as updateLinkColors
};
